<template>
  <div>
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="influencerItems"
      :items-per-page="itemsPerPage"
      item-key="id"
      class="elevation-1"
    >
      <template v-slot:body="{items}">
        <tbody>
          <tr v-for="(item, index) in items" :key="item.instagramHandle">
            <td>
              <a
                target="_blank"
                v-bind:href="'https://instagram.com/' + item.instagramHandle"
              >@{{ item.instagramHandle }}</a>
            </td>
            <td>{{ item.instagramFullname }}</td>
            <td>{{ item.totalFollowers }}</td>
            <td>
              {{ toPercent(item.audienceCredibility) }} %
              <v-icon :color="getCredibilityColor(item.audienceCredibility)">supervised_user_circle</v-icon>
            </td>
            <td>{{ item.engagementRate }} %</td>
            <td>{{ item.amount }}</td>
            <td>{{ item.id ? 'Registered on IMS' : 'Unregistered' }}</td>
            <td>
              <!-- View audience data -->
              <v-btn @click="showReport(item)" color="info" class="ims-action">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">assessment</v-icon>
                  </template>
                  <span>View Audience Data</span>
                </v-tooltip>
              </v-btn>
              <v-btn @click="enterAmount(item, index)" color="info" class="ims-action">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">attach_money</v-icon>
                  </template>
                  <span>Enter payout amount</span>
                </v-tooltip>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
      <!-- ViewInfluencer modal -->
      <view-influencer-modal v-model="viewInfluencerDialog" :influencerData="viewInfluencerData" />
    </v-data-table>
    <!-- Audience data report modal -->
    <audience-data-report-modal
      v-model="viewAudienceDataDialog"
      :audienceData="audienceDataReport"
    />
  </div>
</template>
<script>
import influencerAPIs from './influencerAPIs';
import ViewInfluencerModal from './ViewInfluencerModal';
import AudienceDataReportModal from './AudienceDataReportModal';

export default {
  props: {
    influencers: Array,
    elimination: Boolean
  },
  components: {
    ViewInfluencerModal,
    AudienceDataReportModal
  },
  data() {
    return {
      selected: [],
      viewInfluencerData: null,
      audienceDataReport: null,
      viewAudienceDataDialog: false,
      viewInfluencerDialog: false,
      itemsPerPage: 10,
      headers: [
        {
          text: 'Instagram',
          value: 'igHandle'
        },
        {
          text: 'Name',
          align: 'left',
          sortable: false,
          value: 'instagramFullname'
        },
        { text: 'Followers', value: 'totalFollowers' },
        { text: 'Audience Credibility', value: 'audienceCredibility' },
        { text: 'Engagement', value: 'engagementRate' },
        { text: 'Amount', value: 'amount' },
        { text: 'Registration', value: 'id' },
        { text: 'Actions', value: 'action' }
      ]
    };
  },
  methods: {
    showReport(influencer) {
      influencerAPIs
        .fetchLocalAudienceReport(influencer.id, influencer.instagramID, influencer.instagramHandle)
        .then(resp => {
          this.audienceDataReport = resp.data;
          console.log('viewAudienceData' + resp);
          this.viewAudienceDataDialog = true;
        })
        .catch(err => {
          console.error(err);
        });
    },
    getInfluencerDataToView(influencerID) {
      influencerAPIs
        .getInfluencer(influencerID)
        .then(response => {
          this.viewInfluencerData = response;
          document.getElementById('viewInfluencer').click();
        })
        .catch(error => {
          // Request failed.
          console.log('error', error);
        });
    },
    getCredibilityColor: function(credibility) {
      let rate = this.toPercent(credibility);
      if (rate >= 0 && rate <= 29) {
        return '#f44336';
      } else if (rate >= 30 && rate <= 59) {
        return '#f9a825';
      } else if (rate >= 60 && rate <= 100) {
        return '#4caf50';
      }
    },
    toPercent(num) {
      return (num * 100).toFixed(2);
    },
    async enterAmount(item, index) {
      let {value: amount} = await this.$swal({
        title: 'Enter payout amount for @' + item.instagramHandle,
        showCancelButton: true,
        inputValue: item.amount,
        input: 'text',
        inputValidator: value => {
          if (!value) {
            return 'You need to enter amount!';
          }
          // TODO: Allow user keyin only number
        }
      });
      this.$emit('amountChanged', amount, item)
    },
    eliminateInfluencer(igHandle) {
      this.influencerItems.map(item => {
        if (igHandle === item.instagramHandle) {
          item.status = 1;
        }
      });
    },
    showEliminationStatus(value) {
      if (value === 0) {
        return 'Selected';
      } else if (value === 1) {
        return 'Eliminated';
      } else {
        return 'Pending';
      }
    },
    emitSelected(event) {
      this.$emit('sendSelected', this.selected);
    }
  },
  computed: {
    influencerItems: function() {
      return this.influencers;
    },
    isElimination: function() {
      return this.elimination || false;
    }
  },
  watch: {}
};
</script>
<style>
.ims-action {
  margin: 6px 1px !important;
  min-width: 35px !important;
  padding: 0px !important;
}
</style>



// WEBPACK FOOTER //
// InfluencerDataTable.vue?4d7cb0dc